export function getAudioPermission(callback) {
  // navigator.mediaDevices.getUserMedia(
  //   { audio: true },
  //   () => {
  //     console.log("Permission Granted");
  //     callback && callback();
  //   },
  //   () => {
  //     console.log("Permission Denied");
  //   }
  // );
   navigator.mediaDevices.getUserMedia({ audio: true })
    .then(() => {
      callback && callback();
    })
    .catch(() => {
      setAllOk(false);
    });
}
